// For any custom code - the theme.js is 8000+ lines long
window.addEventListener("DOMContentLoaded", (event) => {
  // Flickity for mobile icon nav
  var elem = document.querySelector('.mobile-nav-images');
    var flkty = new Flickity( elem, {
      // options
      setGallerySize: false,
      prevNextButtons: false
    });
});
// Show and Hide Back To Top Button On Scroll
window.addEventListener("DOMContentLoaded", (event) => {
  backButton = document.querySelector(".back-to-top-position");
  var myScrollFunc = function() {
    const pos = document.documentElement.scrollTop;
    const calcHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scrollValue = Math.round( pos * 100 / calcHeight);
    if (scrollValue >= 10) {
      backButton.classList.add("back-show");
      backButton.classList.remove("back-hide");
    } else {
      backButton.classList.add("back-hide");
      backButton.classList.remove("back-show");
    }
  };
  
  window.addEventListener("scroll", myScrollFunc);
});

//Set sale image src and srcset and also mouseleave on links to change back to it.
document.addEventListener("DOMContentLoaded", (event) => {
  const saleImageSrc = document.querySelector('.megamenu__col:last-child .site-nav__dropdown-link:first-child img').src;
  const saleImageSrcSet = document.querySelector('.megamenu__col:last-child .site-nav__dropdown-link:first-child img').srcset;
  const tentShapeLink = document.querySelectorAll('.menu-item-container:nth-child(2) .site-nav__dropdown-link');
    for (var i = 0; i < tentShapeLink.length; i++) {
          tentShapeLink[i].addEventListener('mouseleave', (event) => {
            document.querySelector('.megamenu__col:last-child .site-nav__dropdown-link:first-child img').src = saleImageSrc;
            document.querySelector('.megamenu__col:last-child .site-nav__dropdown-link:first-child img').srcset = saleImageSrcSet;
            });
    }
});

//Remove shop all nav element from desktop view
document.addEventListener("DOMContentLoaded", (event) => {
  const shopAllTents = document.querySelector(".site-nav__item:nth-child(1) .megamenu__col:first-child");
  const shopAllStoves = document.querySelector(".site-nav__item:nth-child(2) .megamenu__col:first-child");
  const shopAllAccessories = document.querySelector(".site-nav__item:nth-child(3) .megamenu__col:first-child");
  shopAllTents.remove();
  shopAllStoves.remove();
  shopAllAccessories.remove();
});

//Style menu items without images
document.addEventListener("DOMContentLoaded", (event) => {
  const menuItems = document.querySelectorAll('.menu-item');
  for (var i = 0; i < menuItems.length; i++) {
    if (!menuItems[i].querySelector('img')) {
      const menuItemsLinks = menuItems[i].querySelector('a');
      menuItemsLinks.style.marginLeft = "-60px";
      menuItemsLinks.style.fontWeight = "bold";
      menuItemsLinks.style.letterSpacing = "2.64px";
    }
  }
  //Remove href and pointer events on blog text.
  const menuItemsBlog = document.querySelectorAll('.site-nav.site-navigation.left .site-nav__item:nth-child(3) .megamenu__col:nth-child(4) .menu-item:nth-child(2)');
  for (var i = 0; i < menuItemsBlog.length; i++) {
      const menuItemsBlogLinks = menuItemsBlog[i].querySelector('a');
      menuItemsBlogLinks.style.marginLeft = "0";
      menuItemsBlogLinks.removeAttribute("href");
      menuItemsBlogLinks.style.pointerEvents = "none";
  }
});

//Add Carma app to ajax cart
document.addEventListener("DOMContentLoaded", (event) => {
  //Clone Carma app on PDP
  const carmaPDP = document.querySelector('.carmaWrap');
    if(carmaPDP) {
      const clone = carmaPDP.cloneNode(true);
      clone.classList.add('carmaWrap-ajaxcart');
      carmaPDP.after(clone);
    }
  //Prepend cloned element to the top of the ajax cart
  const carmaAjax = document.querySelector('.carmaWrap-ajaxcart');
    if(carmaAjax){
      const paymentButton = document.querySelector('#HeaderCart');
      paymentButton.prepend(carmaAjax);
    }

  const carmaImg = document.querySelector('.carmaModal-image img');
    if(carmaImg){
      const carmaImgSrc = carmaImg.getAttribute('data-src');
      carmaImg.setAttribute('src', carmaImgSrc)
    }
});

//Show Carma popup on Ajax cart
window.addEventListener("load", (event) => {
  const carmaAjaxPopupLink = document.querySelector("div.carmaWrap.carmaWrap-ajaxcart > div.carmaBanner.show > div.carmaBanner-info")
  if(carmaAjaxPopupLink) {
    carmaAjaxPopupLink.addEventListener("click", function (e) {
      document.querySelector(".carmaModal").classList.add("show");
    });
  }
});

//Move Carma app below the cart header
document.addEventListener("DOMContentLoaded", (event) => {
  //Added class to Carma Shopify Section
  const carmaCart = document.querySelector('.template-cart .shopify-app-block .carmaWrap');
  if(carmaCart){
    carmaCart.closest('.shopify-section').classList.add('carmaWrap-container');
  }
  //Moved Carma app to under Cart Header
  const carmaCartContainer = document.querySelector('.carmaWrap-container');
  if(carmaCartContainer) {
    const cartHeader = document.querySelector(".template-cart .cart__page-col");
    cartHeader.prepend(carmaCartContainer);
  }
});

//Fix to accordion heights causing overflow on Safari
document.addEventListener("DOMContentLoaded", () => {
  const faqTitleClicks = document.querySelectorAll(".collapsible-trigger-btn");
  faqTitleClicks.forEach(box => {
    box.addEventListener('click', () => box.nextElementSibling.querySelector(".collapsible-content__inner").classList.toggle("pdp-tab-closed"));
  });
});

//If pre order button is on show, then hide the stock status.
function preOrderButtonCheck() {
  if(document.querySelector('div.product-block.product-block--sales-point > ul > li:nth-child(1) > span > span')) {
    if(document.querySelector('#pre_order_custom')) {
      document.querySelector('div.product-block.product-block--sales-point > ul > li:nth-child(1) > span > span').classList.add('spurit-hidden');
    }
    else {
      document.querySelector('div.product-block.product-block--sales-point > ul > li:nth-child(1) > span > span').classList.remove('spurit-hidden');
    }
  }
}
window.addEventListener("load", () => {
  if(document.location.pathname.indexOf("/products/") === 0) {
    preOrderButtonCheck();
  }
});
document.addEventListener('variant:change', () => {
  setTimeout(preOrderButtonCheck, 300);
});

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);

document.addEventListener('rebuy:smartcart.show', (event) => {
  const smartcarts = document.querySelector("div[data-rebuy-id='162623']")
  smartcarts.style.opacity = 1;
  smartcarts.style.position = "fixed";
  smartcarts.style.display = "block";
});
document.addEventListener('rebuy:smartcart.hide', (event) => {
  const smartcarts = document.querySelector("div[data-rebuy-id='162623']")
  smartcarts.style.opacity = 0;
  smartcarts.style.position = "absolute";
  smartcarts.style.display = "none";
});

document.addEventListener("DOMContentLoaded", (event) => {
  const productBanner = document.querySelector(".product-banners")
  if(productBanner){
    var productBannerSplide = new Splide(productBanner, {
      perPage: 15,
      arrows: false,
      pagination: false,
      breakpoints: {
        1000: {
          type: 'slide',
          perPage: 7
        },
        700: {
          type: 'slide',
          perPage: 6
        },
        520: {
          type: 'slide',
          perPage: 5
        },
        420: {
          type: 'slide',
          perPage: 4
        }
      }
    } );
    productBannerSplide.on( 'overflow', function ( isOverflow ) {
      if ( isOverflow ) {
        // Enough slides
        productBannerSplide.options = {
          arrows: true
        };
      }
    } );
    productBannerSplide.mount();
}
  const pdpMeasurements = document.querySelector(".pdp-measurements-splide")
  if(pdpMeasurements){
    var pdpMeasurementsSplide = new Splide(pdpMeasurements, {
      gap: '3rem',
      padding: '10%',
      pagination: false,
      arrows: false,
      breakpoints: {
        520: {
          padding: '5%',
        },
      }
    } );
    pdpMeasurementsSplide.on( 'overflow', function ( isOverflow ) {
      if ( isOverflow ) {
        // Enough slides
        pdpMeasurementsSplide.options = {
          arrows: true,
          rewind: true,
          type: 'loop',
          padding: '13%',
        };
      }
    } );
    pdpMeasurementsSplide.mount();
  }
  const pdpTrustPilot = document.querySelector(".pdp-trustpilot-splide")
  if(pdpTrustPilot){
    var pdpTrustPilotSplide = new Splide(pdpTrustPilot, {
      perPage: 3,
      pagination: false,
      arrows: false,
      breakpoints: {
        768: {
          type: 'slide',
          perPage: 1,
        }
      }
    } );
    pdpTrustPilotSplide.on( 'overflow', function ( isOverflow ) {
      if ( isOverflow ) {
        // Enough slides
        pdpTrustPilotSplide.options = {
          arrows: true,
          pagination: true,
        };
      }
    } );
    pdpTrustPilotSplide.mount();
}
});
//Set top position based on nav bar height
window.addEventListener("resize", () => {
  const toolbarHeader = document.querySelector(".toolbar-header-container").offsetHeight;
  const pdpTabs = document.querySelector(".section-pdp-tabs");
  if(pdpTabs) {
    pdpTabs.style.top = toolbarHeader + 6 + 'px';
  }
});

//Mutation Observer to move Klaviyo reviews buttons
function waitForElm(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }
      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              observer.disconnect();
              resolve(document.querySelector(selector));
          }
      });
      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}
waitForElm('.kl_reviews__button_bar').then(() => {
  const klaviyoReviewsButtons = document.querySelector(".kl_reviews__button_bar");
  const klaviyoReviewsLoadMore = document.querySelector(".kl_reviews__load_more_button button");
  klaviyoReviewsLoadMore.after(klaviyoReviewsButtons);
});
//Added a fix so by default the social gallery tab, title and cta is hidden, unless there are entires from the FourSixty Social app
waitForElm('.fs-entry-container').then(() => {
  const galleryTab = document.querySelector(".product-tab-item-gallery");
  const galleryTitle = document.querySelector(".social-gallery-title");
  const galleryCTA = document.querySelector(".social-gallery-cta");
  galleryTab.style.display="block";
  galleryTitle.style.display="block";
  galleryCTA.style.display="block";
});

// Mutation observer to check for changes in the Tidio chat iframe's max-height and adjust z-index accordingly
waitForElm('#tidio-chat-iframe').then(() => {
  const tidioChat = document.querySelector('#tidio-chat');
  const tidioIframe = document.querySelector('#tidio-chat-iframe');

  // Define the function to check and set z-index
  function checkMaxHeightAndZIndex() {
    if (!tidioChat || !tidioIframe) return;
    const maxHeight = tidioIframe.style.maxHeight;
    if (maxHeight === "100%") {
      tidioChat.style.zIndex = 100002;
    } else {
      tidioChat.style.zIndex = 99999;
    }
  }

  // Initial check
  checkMaxHeightAndZIndex();

  // Create a dedicated MutationObserver for style changes
  const tidioStyleObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "attributes" && mutation.attributeName === "style") {
        checkMaxHeightAndZIndex();
      }
    }
  });

  // Observe only the style attribute on the iframe
  if (tidioIframe) {
    tidioStyleObserver.observe(tidioIframe, { attributes: true, attributeFilter: ["style"] });
  }
});

// Create a new IntersectionObserver object so when sections over scrolled to, the tab is active
const pdpSections = document.querySelectorAll('[id*="pdp-"]');
const config = {
  root: null,
  rootMargin: '0px',
  threshold: 0.85
};

let observer = new IntersectionObserver(function (entries) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      intersectionHandler(entry); 
    }
  });
}, config);

pdpSections.forEach(pdpSection => {
  observer.observe(pdpSection);
});

function intersectionHandler(entry) {
  const id = entry.target.id;
  const currentlyActive = document.querySelector('.product-tab-item a.active');
  const shouldBeActive = document.querySelector('.product-tab-item a[data-ref=' + id + ']');
  if (currentlyActive) {
    currentlyActive.classList.remove('active');
  }
  if (shouldBeActive) {
    shouldBeActive.classList.add('active');
  }
}

// Add active class to clicked section tab
window.addEventListener("DOMContentLoaded", (event) => {
  document.querySelectorAll(".product-tab-item a").forEach(element => {
    element.addEventListener("click", function() {
        document.querySelectorAll(".product-tab-item a").forEach(el => el.classList.remove("active"));
        this.classList.add("active");
    });
  });
});